const initialState = {
  data: [],
  success: false,
  error: false,
};

export const deleteRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/DELETE_REQUEST_REQUEST`: {
      return initialState;
    }
    case `${namespace}/DELETE_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: true };
    }
    case `${namespace}/DELETE_REQUEST_FAILURE`: {
      return { ...state, data: action.error, success: false, error: true };
    }
    default:
      return state;
  }
};
